<template>
  <el-dialog
    :title="`【${orgName}】组织的终端详情`"
    center
    width="80%"
    :visible.sync="dialogTerminal"
    customClass="sky-terminal__dialog-center"
  >
    <div class="sky-terminal">
      <el-tree
        ref="termianlGroup"
        highlight-current
        node-key="id"
        :defaultExpandedKeys="['root']"
        class="sky-terminal__group"
        :data="terminalGroupList"
        @node-click="handleNodeClick"
      ></el-tree>
      <pagination-table
        class="sky-terminal__table"
        ref="terminalTable"
        :data="terminalList"
        :terminalLimit="terminalLimit"
        :total="terminalsCount"
        :hasSearch="false"
        :page="terminalsPage"
        height="92%"
        :alwaysShowPage="true"
        :searchPlaceholder="$t('articleManage.searchArticlePlaceholder')"
        @prevClick="handleTerminalsPrevClick"
        @nextClick="handleTerminalsNextClick"
        @sizeChange="handleTerminalsSizeChange"
        @filterChange="handleTerminalsFilterChange"
      >
        <template slot="columns">
          <el-table-column prop="category" label="终端名称" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.name ? scope.row.name : '--' }}</template>
          </el-table-column>
          <el-table-column prop="groupName" label="所属终端组" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.groupName ? scope.row.groupName : '--' }}</template>
          </el-table-column>
          <el-table-column
            prop="terminalState"
            label="终端状态"
            :filters="TERMINAL_STATE_FILTERS"
            :filterFooter="false"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div style="display: flex;align-items:center;padding:2px 0;">
                <el-tooltip
                  v-if="scope.row.remoteAutoAgree"
                  :content="$t('activeOrg.remoteAutoAgreeTip')"
                  placement="top"
                >
                  <i class="rcl-icon-yuanchengxiezhu-2 rcl-color-primary rcl-icon--terminalState"></i>
                </el-tooltip>
                <el-tooltip v-if="scope.row.shareStrategy" :content="$t('activeOrg.shareStateTip')" placement="top">
                  <i class="rcl-icon-share rcl-color-primary rcl-icon--terminalState"></i> </el-tooltip
                ><el-tooltip v-if="!scope.row.deployState" :content="$t('activeOrg.unDeployTip')" placement="top">
                  <i class="rcl-icon-warn rcl-color-warn rcl-icon--terminalState"></i>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="terminalDeskState"
            :filters="TERMINAL_DESK_STATE_FILTERS"
            :filterFooter="false"
            label="网络状态"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <sk-icon-status
                :content="getTerminalDeskStateParams(scope.row.terminalDeskState).label"
                :type="getTerminalDeskStateParams(scope.row.terminalDeskState).type"
                simple
              />
            </template>
          </el-table-column>
        </template>
      </pagination-table>
    </div>
  </el-dialog>
</template>
<script>
import { Dialog, Tree, TableColumn, Tooltip } from 'element-ui'

import { SkIconStatus } from 'sk-ui'

import { getTerminalList, getTerminalGroup } from '@/api/activeOrganization'
import PaginationTable from '@/components/paginationTable'

import {
  TERMINAL_DESK_STATE,
  TERMINAL_DESK_STATE_FILTERS,
  TERMINAL_STATE_FILTERS
} from '@/utils/constant/terminalNetStatus'

export default {
  props: {
    orgId: {
      type: String,
      default() {
        return ''
      }
    },
    orgName: {
      type: String,
      default() {
        return ''
      }
    }
  },
  components: {
    [Dialog.name]: Dialog,
    [Tree.name]: Tree,
    PaginationTable,
    [TableColumn.name]: TableColumn,
    [Tooltip.name]: Tooltip,
    SkIconStatus
  },
  data() {
    return {
      terminalLoading: false,
      terminalList: [],
      terminalLimit: 20,
      terminalsCount: 0,
      terminalsPage: 0,
      terminalGroupList: [
        {
          id: 'root',
          label: '全部终端',
          children: null
        }
      ],
      dialogTerminal: false,
      TERMINAL_STATE_FILTERS,
      TERMINAL_DESK_STATE_FILTERS,
      groupId: '',
      exactMatchArr: []
    }
  },
  created() {},
  mounted() {},
  methods: {
    showTerminals() {
      this.dialogTerminal = true
      this.getTerminalGroup()
      this.$nextTick(() => {
        this.$refs.termianlGroup.$nextTick(() => {
          this.$refs.termianlGroup.setCurrentKey('root')
        })
      })
    },
    getTerminalList() {
      if (this.terminalLoading) {
        return
      }
      this.terminalLoading = true
      console.log('this.exactMatchArr', this.exactMatchArr)
      getTerminalList({
        orgId: this.orgId,
        limit: this.terminalLimit,
        page: this.terminalsPage,
        exactMatchArr: this.exactMatchArr
      })
        .then(res => {
          this.terminalList = res.data.content.itemArr
          this.terminalsCount = res.data.content.total
        })
        .finally(() => {
          this.terminalLoading = false
        })
    },
    getTerminalGroup() {
      getTerminalGroup({
        orgId: this.orgId
      })
        .then(res => {
          console.log('res', res)
          this.terminalGroupList[0].children = res.data.content.itemArr
        })
        .finally(() => {
          this.getTerminalList()
        })
    },
    getTerminalDeskStateParams(state) {
      return TERMINAL_DESK_STATE[state]
    },
    handleTerminalsPrevClick() {
      this.terminalsPage--
      this.getTerminalList()
    },
    handleTerminalsNextClick() {
      this.terminalsPage++
      this.getTerminalList()
    },
    handleTerminalsSizeChange(num) {
      this.terminalsPage = 0
      this.terminalLimit = num
      this.getTerminalList()
    },
    handleTerminalsFilterChange() {
      const _this = this
      this.$refs.terminalTable.$refs.paginationTable.columns.map(item => {
        if (item.filterOpened) {
          console.log('-----item----', item, item.property)
          _this.setExactMatchArr(item.property, item.filteredValue.length ? item.filteredValue : '')
        }
      })

      this.terminalsPage = 0
      this.getTerminalList()
    },
    handleNodeClick(data, node) {
      if (data.id === 'root') {
        node.expanded = true
        this.groupId = ''
      } else {
        this.groupId = data.id
      }

      this.setExactMatchArr('groupId', [this.groupId])
      this.getTerminalList()
    },
    setExactMatchArr(name, val) {
      let hasNameVal = false
      for (let i in this.exactMatchArr) {
        if (this.exactMatchArr[i].name === name) {
          if (!val) {
            this.exactMatchArr.splice(i, 1)
          } else {
            this.exactMatchArr[i].valueArr = val
          }

          hasNameVal = true
          break
        }
      }
      if (!hasNameVal) {
        this.exactMatchArr.push({
          name: name,
          valueArr: val
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
@include b(terminal) {
  display: flex;
  flex-direction: row;
  height: 100%;
  width: 100%;
  @include e(group) {
    width: 300px;
    flex-shrink: 0;
    max-height: 100%;
    overflow-y: auto;

    background-color: rgba(245, 245, 246, 0.3);
  }
  @include e(table) {
    flex: 1;
    width: calc(100% - 300px);
    max-height: 100%;
    // padding-left: 20px;
  }
}
</style>
<style lang="scss">
.sky-terminal__dialog-center {
  margin-top: 0 !important;
  top: 50% !important;
  height: 80%;
  transform: translateY(-50%);
  .el-dialog__body {
    height: calc(100% - 32px);
  }
}
.rcl-color-warn {
  color: $--color-warning;
}
.rcl-color-primary {
  color: $--color-primary;
}
</style>
